import React, { Component } from "react";
import Slider from "react-slick";
import CardCurrent from "./card";
import CardPast from "./card_past";

import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import "./slider.css";
import leftArrow from "../images/arrow-left.png"
import rightArrow from "../images/arrow-right.png"

import img1 from "../images/speak.png"
import img2 from "../images/speak2.png"
import img3 from "../images/speak3.png"
import img4 from "../images/speak4.png"
import img5 from "../images/speak5.png"
import img6 from "../images/speak6.png"
import img7 from "../images/speak7.png"
import pdf1 from "../posters/ACMC-OnurErten.pdf"
import pdf2 from "../posters/ACMC-NurUnal.pdf"
import pdf3 from "../posters/ACMC-DogaMuratKurkcuoglu.pdf"
import pdf4 from "../posters/ACMC-Po-YaoChang.pdf"
import pdf5 from "../posters/ACMC-PouyanGhaemi.pdf"
import pdf6 from "../posters/ACMC-HiteshChanglani.pdf"
import pdf7 from "../posters/ACMC-CerenDag.pdf"

export default class SimpleSlider extends Component {

  render() {
    const SlickArrowLeft = ({ currentSlide, slideCount, ...props }) => (
      <img src={leftArrow} alt="prevArrow" {...props} sizes='90px'/>
  );

    const SlickArrowRight = ({ currentSlide, slideCount, ...props }) => (
    <img src={rightArrow} alt="nextArrow" {...props} width='90px' />
  );
    const settings = {
      // className: "center",
      dots: true,
      arrows: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToscroll: 1,
      initialSlide: 6,
      centerPadding: "100px",
      // cssEase:'linear',
      // variableWidth: 'true',
      // variableHeight: 'true',
      prevArrow: <SlickArrowLeft />,
      nextArrow: <SlickArrowRight />,
      // slidesToScroll: 0
    };
    return (
      <section className="container" >
          <div className="card__container">
            <div className="card__content">
              <Slider {...settings}>
                  {/* <CardPast name="Some Arbitrarly Hard Condense Matter Topic presented in the past" date="12 December"/> */}
                  <CardPast img={img1} pdf={pdf1} name="Exploring emergent phases in moiré magnets: 
                  fractionalization, fragmentation and new particles " date="16 January, Tuesday"/>
                  <CardPast img={img2} pdf={pdf2} name="Multi-level Topology and Non-Abelian Braiding of Band Singularities" date="30 January, Tuesday"/>
                  <CardPast img={img5} pdf={pdf5} name="Quantum algorithm to realize and study fractional Hall states and their dynamics on near term quantum computers: A tabletop experiment an quantum gravity" date="13 February, Tuesday"/>
                  <CardPast img={img4} pdf={pdf4} name="Some aspects in many-body quantum dynamics: from multi-channel Kondo impurities to entanglement transition in SU(1,1) periodically driven systems" date="27 February, Tuesday"/>
                  <CardPast img={img3} pdf={pdf3} name="Quantum simulation of $\phi^4$ theories in qudit systems" date="12 March, Tuesday"/>
                  <CardPast img={img6} pdf={pdf6} name="Novel phases and dynamics af strongly-correlated magnetic quantum matter" date="26 March, Tuesday"/>
                  <CardCurrent img={img7} pdf={pdf7} name="Breaking ergodicity: quantum scars, quantum many-body scars and regular eigenstates" date="9 April, Tuesday"/>
            </Slider>
            </div>
          </div>
      </section>
    );
  }
}